var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchMagnifier({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-magnifier",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    fillOpacity: 0,
    r: 7,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M13 13l4.393 4.393"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagnifier);
export default __webpack_public_path__ + "static/media/search-magnifier.fee732c6.svg";
export { ForwardRef as ReactComponent };